/** Dashboard KPIs + analytics. */
import { endpoints } from '@/config/env';
import type { DateRange } from '@/lib/dateRange';
import type { AnalyticsResponse, DashboardResponse } from '@/types';
import { request } from './client';

export function fetchDashboard(range: DateRange, signal?: AbortSignal): Promise<DashboardResponse | null> {
  return request<DashboardResponse | null>(endpoints.dashboard(range), { signal });
}

export function fetchAnalytics(range: DateRange, signal?: AbortSignal): Promise<AnalyticsResponse | null> {
  return request<AnalyticsResponse | null>(endpoints.analytics(range), { signal });
}
